import { connect } from "react-redux";
import { RootState } from "../../../store/store";
import FormGroup from "../../../components/common/FormGroup";
import Select from "../../../components/common/controls/Select";
import ExampleSelectionFieldWithIcon from "./ExampleSelectionFieldWithIcon";
import powerBIIcon from "static/images/power-bi.svg";
import { DemoUsageType } from "../../../shared/enums/DemoUsageTypeEnum";
import SignInInstructionToDownloadExample from "./SignInInstructionToDownloadExample";

interface Props {
  demoExampleData: any[];
  logDownload: (demoId: string, usageType: DemoUsageType) => void;
  isAuthenticated?: boolean;
}

export function DownloadPowerBIExample(props: Props) {
  const { demoExampleData, logDownload, isAuthenticated } = props;
  const defaultText = "Please select an example here";

  const handlePowerBISelectionChange = ({ selectedItem }: any) => {
    window.open(selectedItem.powerBIUrl, "_parent");
    logDownload(selectedItem.id, DemoUsageType.DownloadPowerBI);
  };

  const TextFieldWithPowerBIIcon = (data: any) => {
    return (
      <ExampleSelectionFieldWithIcon
        data={data}
        imageSource={powerBIIcon}
        defaultText={defaultText}
      />
    );
  };

  return (
    <FormGroup label="Download example data for PowerBI:">
      {isAuthenticated ? (
        <Select
          dataSource={demoExampleData}
          displayExpr="title"
          valueExpr="id"
          className="h-12 w-88"
          fieldRender={TextFieldWithPowerBIIcon}
          onSelectionChanged={handlePowerBISelectionChange}
        />
      ) : (
        <SignInInstructionToDownloadExample />
      )}
    </FormGroup>
  );
}

const mapStateToProps = (state: RootState, props: any) => {
  return {
    demoExampleData: state.demoData.demoExampleData,
    isAuthenticated: state.authData.isAuthenticated,
    ...props,
  };
};

export default connect(mapStateToProps)(DownloadPowerBIExample);
